const resources = [
  {
    icon: "ri-government-line",
    title: "Kansas City Regional Passport Agency",
    desc: "Emergency in-person appointments for travel within 14 days. 1 Pershing Rd, Kansas City, MO 64108.",
    link: "https://travel.state.gov/content/travel/en/passports/get-fast/passport-agencies.html",
    label: "View Agency Info",
  },
  {
    icon: "ri-flight-takeoff-line",
    title: "Kansas City International Airport (MCI)",
    desc: "Primary international airport for Lee's Summit and Jackson County. 25 minutes north of Lee's Summit via I-435.",
    link: "https://www.flykci.com",
    label: "MCI Flight Info",
  },
  {
    icon: "ri-mail-line",
    title: "Lee's Summit Post Office — Chipman Road",
    desc: "Main passport acceptance location for Lee's Summit. 400 NW Chipman Rd, Lee's Summit, MO 64063.",
    link: "https://tools.usps.com/find-location.htm",
    label: "Find Locations",
  },
  {
    icon: "ri-book-open-line",
    title: "U.S. State Department Passport Info",
    desc: "Official government information on passport requirements, forms, fees, and processing times.",
    link: "https://travel.state.gov/content/travel/en/passports.html",
    label: "State Dept Website",
  },
];

export default function LeeSummitHelpfulResourcesSection() {
  return (
    <section id="local-resources" className="bg-[#F7F8FA] py-20 md:py-28">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-12">
          <p className="text-[#F6C344] text-xs font-bold uppercase tracking-[0.2em] mb-3">Local Resources</p>
          <h2 className="font-serif text-3xl md:text-4xl font-bold text-[#1A365D] mb-4">
            Helpful Resources for Lee&apos;s Summit &amp; Jackson County Travelers
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {resources.map((r, i) => (
            <div key={i} className="bg-white border border-gray-200 rounded-lg p-6 flex gap-4">
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#EEF2F8] flex-shrink-0">
                <i className={`${r.icon} text-[#1A365D] text-xl`}></i>
              </div>
              <div className="flex-1">
                <h3 className="font-bold text-[#1A365D] text-sm mb-1">{r.title}</h3>
                <p className="text-gray-500 text-sm leading-relaxed mb-3">{r.desc}</p>
                <a
                  href={r.link}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="inline-flex items-center gap-1.5 text-[#1A365D] font-semibold text-xs hover:text-[#F6C344] transition-colors whitespace-nowrap"
                >
                  {r.label} <i className="ri-external-link-line"></i>
                </a>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}